import { primaryColor, secondaryColor } from '@/constants/styles';
import Vue from 'vue';
import Vuetify from 'vuetify/lib/framework';

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    themes: {
      light: {
        primary: primaryColor,
        secondary: secondaryColor,
        accent: '#8c9eff',
        error: '#b71c1c',
      },
      dark: {
        primary: primaryColor,
        secondary: secondaryColor,
      },
    },
  },
});
